import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import "../styles/country.css";

const CountryPage = ({ darkMode }) => {
  const { name } = useParams();
  const [country, setCountry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(`https://restcountries.com/v2/name/${name}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message);
        }

        setCountry(data[0]);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    }

    fetchData();
  }, [name]);

  return (
    <div id="indiviual" className={darkMode ? "dark-mode" : "light-mode"}>
      
      <div className="country-container">
        {loading && <div className="loading">Loading...</div>}
        {error && <div className="error">{error}</div>}
        {!loading && !error && country && (
          <div className='mai'>
            <img src={country.flags.svg} alt="flag" />
            <div className="inf">
              <h1>{country.name}</h1>
              <p>Native-Name: <span className='not'>{country.nativeName}</span></p>
              <p>Region: <span className='not'>{country.region}</span></p>
              <p>Capital: <span className='not'>{country.capital}</span></p>
              <p>Population: <span className='not'>{country.population.toLocaleString()}</span></p>
            </div>
            <div className="fle">
              <p>Top-level Domain:  <span className='not'>{country.topLevelDomain[0]}</span></p>
              <p>Curriences: <span className='not'>{country.currencies[0].name}</span></p>
              <p>Languages: <span className='not'>{country.languages.map(language => language.name).join(", ")}</span></p>
            </div>
            <div className="help">
            <p>Border Countries:</p>
            <div>
              {
                country.borders.map((border) => (
                  <button key={border}>{border}</button>
                ))
              }
            </div>


            </div>
            



          </div>
        )}
      </div>
    </div>
  );
};

export default CountryPage;
